import styled from '@emotion/styled';
import { borderColor } from '../TableRowContainer/TableRowContainer.styled';
import { StyledProps } from './TableContainer.types';
import { variant } from 'styled-system';

const BORDER_RADIUS_AMOUNT = '8px';
const BORDER = `1px solid ${borderColor}`;

export const StyledTable = styled.table<StyledProps>`
  width: ${(props) => props.width || '100%'};
  justify-content: space-evenly;
  align-items: center;
  border: ${BORDER};
  margin: 0px auto;
  margin-bottom: 30px;
  overflow-x: scroll;
  line-height: 20px;
  font-family: var(--secondary-font);
  table-layout: ${(props) => props.rowWidthEqual && 'fixed'};

  ${variant({
    prop: 'borderVariant',
    variants: {
      rectangle: {
        borderCollapse: 'collapse',
      },
      rounded: {
        borderRadius: BORDER_RADIUS_AMOUNT,
        borderCollapse: 'separate',
        borderSpacing: 0,
        '&>thead': {
          borderTopLeftRadius: BORDER_RADIUS_AMOUNT,
          borderTopRightRadius: BORDER_RADIUS_AMOUNT,
          '&>th, &>tr>th': {
            borderBottom: BORDER,
          },
          '&>th:first-of-type, &>tr>th:first-of-type': {
            borderTopLeftRadius: BORDER_RADIUS_AMOUNT,
            borderLeft: 0,
          },
          '&>th:last-of-type, &>tr>th:last-of-type': {
            borderTopRightRadius: BORDER_RADIUS_AMOUNT,
          },
        },
        '&>tbody': {
          '&>tr+tr>td': {
            borderTop: BORDER,
          },
          '&>tr:last-of-type': {
            borderBottomLeftRadius: BORDER_RADIUS_AMOUNT,
            '&>td:first-of-type': {
              borderBottomLeftRadius: BORDER_RADIUS_AMOUNT,
            },
            '&>td:last-of-type': {
              borderBottomRightRadius: BORDER_RADIUS_AMOUNT,
            },
          },
        },
      },
    },
  })}
`;

export const Caption = styled.caption`
  text-align: start;
  padding-bottom: 30px;
  font-weight: bold;
  font-size: var(--text-md);
`;
